import i18n from 'modules/core/lib/i18n'
import { StatusVariant } from '@factorialco/f0-react'
import { TrainingsValueObjectsTrainingClassStatusEnum } from 'generated/resources/graphql'

export const trainingGroupStatusVariant = (
  status: TrainingsValueObjectsTrainingClassStatusEnum
): StatusVariant => {
  switch (status) {
    case 'planned':
      return 'neutral'
    case 'ongoing':
      return 'info'
    case 'completed':
      return 'positive'
  }
}

export const trainingGroupStatusLabel = (
  status: TrainingsValueObjectsTrainingClassStatusEnum
): string => {
  switch (status) {
    case 'planned':
      return i18n.t('trainings.classes.status.planned')
    case 'ongoing':
      return i18n.t('trainings.classes.status.ongoing')
    case 'completed':
      return i18n.t('trainings.classes.status.completed')
  }
}
